import {ChartCard} from './chart-card';

function init() {
	initCharts();
}

function initCharts() {
	const dataStringyfied = document.querySelector('#js-cope-charts').dataset.chartData;
	const data = JSON.parse(dataStringyfied);

	new ChartCard(
		document.querySelector('#js-cope-chart-investigated'),
		'investigated',
		data
	).init();

	new ChartCard(
		document.querySelector('#js-cope-chart-viewed'),
		'viewed',
		data
	).init();
}

export {init};
